import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Grid, Card, Box, Typography, FormControl, TextField, Button, FormControlLabel, Checkbox, Snackbar, Alert } from "@mui/material";
import { API_ENDPOINTS } from "../../../config/api";

const CreateProductTypeForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    publish: false,
    pieces: false,
  });

  const navigate = useNavigate();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success", // 'success' | 'error'
  });
  const [redirectOnClose, setRedirectOnClose] = useState(false);

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar((prev) => ({ ...prev, open: false }));
    if (redirectOnClose) {
      navigate("/product-types");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(API_ENDPOINTS.PRODUCT_TYPES.CREATE, {
        name: formData.name,
        publish: formData.publish,
        pieces: formData.pieces,
      });
      setSnackbar({
        open: true,
        message: "Product Type created successfully!",
        severity: "success",
      });
      setRedirectOnClose(true);
    } catch (error) {
      console.error("Error creating product type:", error.response?.data || error.message);
      setSnackbar({
        open: true,
        message: "Error creating product type: " + (error.response?.data?.message || "Something went wrong"),
        severity: "error",
      });
      setRedirectOnClose(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Card sx={{ p: 3 }}>
            <Typography variant="h5" sx={{ mb: 2 }}>
              Add A Product Type
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <TextField
                    label="Product Type Name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="publish"
                      checked={formData.publish}
                      onChange={handleChange}
                    />
                  }
                  label="Publish"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="pieces"
                      checked={formData.pieces}
                      onChange={handleChange}
                    />
                  }
                  label="Pieces"
                />
              </Grid>
            </Grid>
            <Box mt={2}>
              <Button type="submit" variant="contained">
                Create Product Type
              </Button>
            </Box>
          </Card>
        </Grid>
      </Grid>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={1000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateProductTypeForm;